import { ResourceLookUpConstants } from '../constants';
export const RESOURCE_LOOKUP_GET_REPAIR_RESOURCES = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_REPAIR_RESOURCES`;
export const RESOURCE_LOOKUP_GET_REPAIR_RESOURCES_SUCCESS = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_REPAIR_RESOURCES_SUCCESS`;
export const RESOURCE_LOOKUP_GET_REPAIR_RESOURCES_FAILURE = `${ResourceLookUpConstants.MODULE_PREFIX}_GET_REPAIR_RESOURCES_FAILURE`;
export const getRepairResourcesAction = (repairResourceLookupPayload, isResourceRepairOrchestratorUrl) => ({
    type: RESOURCE_LOOKUP_GET_REPAIR_RESOURCES,
    payload: { repairResourceLookupPayload, isResourceRepairOrchestratorUrl }
});
export const getRepairResourcesSuccessAction = (resources) => ({
    type: RESOURCE_LOOKUP_GET_REPAIR_RESOURCES_SUCCESS,
    payload: resources
});
export const getRepairResourcesFailureAction = (failureMessage) => ({
    type: RESOURCE_LOOKUP_GET_REPAIR_RESOURCES_FAILURE,
    payload: { failureMessage }
});
//# sourceMappingURL=repairResourceLookupActions.js.map